module.exports = __webpack_public_path__ + "img/rock-big-05.a1f397e3.png";